import { SettingsAccordion } from "../SettingsAccordion";
import { companySections, individualSections, Section, SectionsByCategory } from "../../  config/sectionsConfig";

export interface ProfileManagementProps {
  type: "company" | "individual";
  category: keyof SectionsByCategory;
}

export function ProfileManagement({ type, category }: ProfileManagementProps) {
  const sectionsByCategory: SectionsByCategory = type === "company" ? companySections : individualSections;

  const sections: Section[] = sectionsByCategory[category];

  return <SettingsAccordion sections={sections} />;
}
